import Null from '.null';

export let indent = '\t';
export let newline = '\n';
export let newlineSelector = true;
export let newlineProperty = true;

const OPTIONS          = Null({
	indent,
	newline,
	newlineSelector,
	newlineProperty,
});

export { Options as default };
                                            
const Options = (options          = OPTIONS) => {
	( {
		indent = '\t',
		newline = '\n',
		newlineSelector = true,
		newlineProperty = true,
	} = options );
};
